import React from 'react';
import { useField } from 'formik';
import { Box, Typography, FormHelperText, InputBase } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

const CustomInput = withStyles((theme) => ({
    root: {
        'label + &': {
            marginTop: theme.spacing(3),
        },
    },
    input: {
        borderRadius: '6px',
        position: 'relative',
        backgroundColor: '#fff !important',
        color: '#575757 !important',
        border: '1px solid #e5e5ea',
        marginTop: '5px',
        fontSize: 14,
        width: 'auto',
        maxWidth: '375px',
        padding: '7px 11px',
        '&:focus': {
            borderColor: '#1675e0',
        },
        '&:hover': {
            borderColor: '#1675e0'
        },
        '&:-webkit-autofill': {
            WebkitBoxShadow: '0 0 0 1000px white inset',
            '-webkit-text-fill-color': '#575757 !important'
        }
    },
}))(InputBase);

const MUIInputElement = ({ showCustomError, customError, label, ...props }) => {
    const [field, meta] = useField(props);
    const showError = meta.touched && meta.error;
    return (
        <Box sx={{ marginBottom: '24px', maxWidth: '295px' }}>
            <Typography>
                {label}
            </Typography>
            <CustomInput {...props} {...field}/>
            <FormHelperText error={!!showError}>{showError}</FormHelperText>
            {showCustomError && <FormHelperText error={showCustomError}>{customError}</FormHelperText>}
        </Box>
    );
};

export default MUIInputElement;
